import {
  DeleteEmailTemplates,
  GetEmailTemplates,
  PreviewEmail,
  PublishEmailTemplate,
  SendSampleEmail,
} from "../../DriveScout/API/models/EmailTemplates";

const state = {
  templates: [],
  preview: {
    html: null,
    updated_at: null,
  },
};

const mutations = {
  PREVIEW_EMAIL_TEMPLATE(state, template) {
    state.preview.html = template;
  },
  SET_PREVIEW_EMAIL_TEMPLATE(state, template) {
    state.preview.html = template.template;
  },
  SET_EMAIL_PREVIEW_UPDATED_AT(state, date) {
    state.preview.updated_at = date;
  },
  SET_EMAIL_TEMPLATES(state, templates) {
    state.templates = templates;
  },
  UPDATE_EMAIL_TEMPLATE(state, template) {
    state.templates = state.templates.map((emailTemplate) => {
      if (emailTemplate.name === template.name) {
        return template;
      }
      return emailTemplate;
    });
  },
};

const actions = {
  PREVIEW_EMAIL_TEMPLATE({ commit }, template) {
    PreviewEmail(template).then((response) => {
      commit("PREVIEW_EMAIL_TEMPLATE", response.data.template);
      commit("SET_EMAIL_PREVIEW_UPDATED_AT", new Date());
    });
  },
  SET_PREVIEW_EMAIL_TEMPLATE({ commit }, template) {
    commit("SET_PREVIEW_EMAIL_TEMPLATE", template);
    commit("SET_EMAIL_PREVIEW_UPDATED_AT", new Date());
  },
  SET_EMAIL_PREVIEW_UPDATED_AT({ commit }, date) {
    commit("SET_EMAIL_PREVIEW_UPDATED_AT", date);
  },
  PUBLISH_EMAIL_TEMPLATE({ commit }, templateData) {
    return PublishEmailTemplate(templateData).then((response) => {
      commit("SET_EMAIL_PREVIEW_UPDATED_AT", new Date());
      commit("SET_PREVIEW_EMAIL_TEMPLATE", response.data.template);
      commit("UPDATE_EMAIL_TEMPLATE", response.data.template);
      return response;
    });
  },
  SEND_SAMPLE_EMAIL({ commit }, sampleData) {
    return SendSampleEmail(sampleData).then((response) => {
      return response;
    });
  },
  SET_EMAIL_TEMPLATES({ commit }, templates) {
    commit("SET_EMAIL_TEMPLATES", templates);
  },
  GET_EMAIL_TEMPLATES({ commit }) {
    return GetEmailTemplates().then((response) => {
      commit("SET_EMAIL_TEMPLATES", response.data);
    });
  },
  UPDATE_EMAIL_TEMPLATE({ commit }, template) {
    commit("UPDATE_EMAIL_TEMPLATE", template);
  },
  DELETE_EMAIL_TEMPLATE({ commit }, template) {
    return DeleteEmailTemplates(template).then((response) => {
      commit("UPDATE_EMAIL_TEMPLATE", response.data.template);
      return response;
    });
  },
};

const getters = {
  emailPreviewUpdatedOn: (state) => state.preview.updated_at,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

